<mat-form-field class="white dense-2 w-40" appearance="outline">
  <button class="pl-3"
    matPrefix
    aria-label="Remove"
    (click)="incrementValue(-_step)"
    [disabled]="disabled || shouldDisableDecrement(_value)">
    <mat-icon>remove</mat-icon>
  </button>
  <input matInput type="number" [(ngModel)]="_value" class="increment border-l border-r" disabled/>
  <button class="pr-3"
    matSuffix
    aria-label="Add"
    (click)="incrementValue(_step)"
    [disabled]="disabled || shouldDisableIncrement(_value)">
    <mat-icon>add</mat-icon>
  </button>
</mat-form-field>
